module.exports = __webpack_public_path__ + "img/icon-check-de-survey.e11b7716.svg";